import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import * as services from "../../services/saleng";
import toast from "react-hot-toast";

const SubCategoryFormDialog = ({
  open,
  onClose,
  onSuccess,
  categoryId,
  initialData,
}) => {
  const isEdit = Boolean(initialData);
  const [name, setName] = useState("");

  useEffect(() => {
    if (!initialData) return;
    setName(initialData.name);
  }, [initialData]);

  const handleConfirm = async () => {
    const trimmed = name.trim();

    console.log("initialData ", initialData);
    try {
      if (isEdit) {
        await services.editSubCategory(
          { name: trimmed, categoryId: categoryId },
          initialData.id
        );
        toast.success("แก้ไขหมวดหมู่ย่อยเรียบร้อย");
      } else {
        await services.createSubCategory(
          { name: trimmed, categoryId: categoryId },
        );
        toast.success("เพิ่มหมวดหมู่ย่อยเรียบร้อย");
      }

      setName("");
      onSuccess();
      onClose();
    } catch (err) {
      toast.error("เกิดข้อผิดพลาด");
      console.error(err);
    }
  };

  const handleClose = async () => {
    setName("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isEdit ? "แก้ไขหมวดหมู่สินค้าย่อย" : "เพิ่มหมวดหมู่สินค้าย่อย"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <TextField
            label="ชื่อหมวดหมู่สินค้าย่อย"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            helperText="กรอกชื่อหมวดหมู่ย่อย เช่น เหล็กเส้น"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>ยกเลิก</Button>
        <Button onClick={handleConfirm} variant="contained" color="success">
          {isEdit ? "บันทึกการแก้ไข" : "เพิ่มหมวดหมู่ย่อย"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubCategoryFormDialog;
